<template>
  <div class="van-hairline--bottom">
    <van-field
      :label="label"
      :value="value"
      :placeholder="placeholder"
      readonly
      :is-link="isLink"
      @focus="onFocus"
      @click="onClick"
    />
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        :type="type"
        :value="defaultValue"
        :min-date="minDate"
        :max-date="maxDate"
        :min-hour="minHour"
        :max-hour="maxHour"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "date-field",
  data() {
    return {
      showDatePicker: false
    };
  },
  props: {
    type: {
      type: String,
      default: "date"
    },
    value: {
      type: String,
      default: function() {
        return moment().format("YYYY-MM-DD");
      }
    },
    label: {
      type: String,
      default: "日期"
    },
    placeholder: {
      type: String,
      default: "必填，选择日期"
    },
    minDate: {
      type: Date
    },
    maxDate: {
      type: Date
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    isLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    defaultValue() {
      if (this.type === "time") {
        return this.value;
      } else {
        return new Date(this.value);
      }
    }
  },
  methods: {
    onFocus() {
      document.activeElement.blur();
    },
    onClick() {
      this.showDatePicker = true;
    },
    confirm(value) {
      this.showDatePicker = false;

      if (this.type === "date") {
        this.$emit("input", moment(value).format("YYYY-MM-DD"));
      } else {
        this.$emit("input", value);
      }
    },
    cancel() {
      this.showDatePicker = false;
    }
  },
  watch: {
    showDatePicker(val) {
      this.$emit("showPopupChange", val);
    }
  }
};
</script>
